import { createSlice } from "@reduxjs/toolkit";
import { addNewCard, deleleteGcard, getCard, getCards, updateGCard } from "../actions/gcardAction";
const INIT_STATE = {
  isLoading: false,
  cards: [],
  card: {},
  totalCount: 0,
  totalAmount: 0,
  isError: false,
  error: "",
};

const gcardSlice = createSlice({
  name: "gcard",
  initialState: INIT_STATE,
   reducers: {
    filterTableDate: (state, action) => {

      const tableData = action.payload;
     
      const filteredTotalCount = tableData.reduce(
        (acc, item) => acc + Number(item.count || 0),
        0
      );

      const filteredTotalAmount = tableData.reduce(
        (acc, item) =>
          acc + (Number(item.count || 0) * Number(item.price || 0)),
        0
      );
      state.cards = tableData;
      state.totalCount = filteredTotalCount;
      state.totalAmount = filteredTotalAmount;
    }
  },
  extraReducers: (builder) => {
    //add new card
    builder
      .addCase(addNewCard.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.error = "";
      })
      .addCase(addNewCard.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.error = "";
        state.cards = [...state.cards, action.payload];
      })
      .addCase(addNewCard.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.payload;
      })
      //update card
      .addCase(updateGCard.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.error = "";
      })
      .addCase(updateGCard.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.error = "";
        const index = state.cards.findIndex(
          (card) => card.id === action.payload.id,
        );
        state.cards.splice(index, 1, action.payload);
      })
      .addCase(updateGCard.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.payload;
      })
      //delete card
      .addCase(deleleteGcard.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.error = "";
      })
      .addCase(deleleteGcard.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.error = "";
        state.cards = state.cards.filter(
          (card) => card.id !== Number(action.payload),
        );
      })
      .addCase(deleleteGcard.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.payload;
      })
      //get card
      .addCase(getCard.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.error = "";
      })
      .addCase(getCard.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.error = "";
        state.card = action.payload;
      })
      .addCase(getCard.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.payload;
      })
      //get cards
      .addCase(getCards.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.error = "";
      })
      .addCase(getCards.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.error = "";
        state.cards = action.payload.cards;
        state.totalAmount = action.payload.totalAmount;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(getCards.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.cards = [];
        state.totalAmount = 0;
        state.totalCount = 0;
        state.error = action.payload;
      });
  },
});
export const { filterTableDate } = gcardSlice.actions;
export default gcardSlice.reducer;
